import { stats } from '@/mocks/comics';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-3/5">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-snug mb-8">
              用心打造<br />最优质的<br />漫画阅读体验
            </h2>
            <div className="grid grid-cols-3 gap-6 md:gap-8">
              {stats.map((stat, index) => (
                <div key={index} className="relative">
                  {index > 0 && (
                    <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-3 md:-ml-4 w-px h-10 bg-background-300"></div>
                  )}
                  <div className="pl-3 md:pl-4">
                    <div className="text-3xl md:text-4xl font-black text-primary-500 mb-1">
                      {stat.value}{stat.suffix}
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-2/5">
            <div className="relative h-48 md:h-64 rounded-lg overflow-hidden bg-gradient-to-br from-primary-100/60 via-primary-50/40 to-accent-100/40">
              <div className="absolute top-6 right-8 w-20 h-20 rounded-2xl bg-primary-200/60 rotate-12"></div>
              <div className="absolute bottom-8 left-6 w-24 h-16 rounded-xl bg-accent-200/50 -rotate-6"></div>
              <div className="absolute top-10 left-10 w-16 h-16 rounded-full bg-secondary-200/50"></div>
              <div className="absolute bottom-10 right-12 w-12 h-12 rounded-lg bg-primary-300/40 rotate-45"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-5xl md:text-6xl font-black text-primary-500 mb-2">99.2%</div>
                  <p className="text-sm text-foreground-600 font-medium">用户好评率</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}